/**
 * The ixDialogToolbar directive displays the standard (currently abort) and the transcluded buttons.
 * Use the 'hide-abort' attribute to hide the abort-button.
 *
 * @param hide-abort hides the abort button
 */
angular.module('impactx.toolbar').directive('ixDialogToolbar', function() {
    return {
        scope: false,
        restrict: 'E',
        controller: 'DialogToolbarCtrl',
        controllerAs: 'dialogToolbarCtrl',
        templateUrl: 'shared/toolbar/templates/dialogtoolbar.tmpl.html',
        transclude: true,
        link: function(scope, element, attrs, controller) {

            var initFormController = function() {
                if(!scope.dialogData) {
                    var formController = element.controller('form');
                    if(formController) {
                        scope.dialogData = formController;
                    }
                }
                if(scope.dialogData) {
                    var deregisterShowAbort = scope.$watch('dialogData.$dirty', function(newValue) {
                        if(newValue) {
                            controller.toggleAbortLabel();
                            deregisterShowAbort();
                        }
                    }, true);
                }
            };

            var hideAbortButton = attrs.hasOwnProperty('hideAbort');

            if(hideAbortButton) {
                scope.hideAbort = true;
                attrs.$observe('hideAbort', function(newValue) {
                    if(angular.isDefined(newValue) && newValue.length > 0) {
                        if(newValue === 'false') {
                            scope.hideAbort = false;
                            initFormController();
                        }
                    }
                });
            }
            else {
                initFormController();
            }

            var abortCallbackFunction = attrs.hasOwnProperty('abortCallbackFunction');
            if(abortCallbackFunction) {
                scope.abortCallbackFunction = scope.$eval(attrs.abortCallbackFunction);
            }
        }
    };
});